import { render, staticRenderFns } from "./eAristoStudentTopicsRootView.vue?vue&type=template&id=2af10b04"
import script from "./eAristoStudentTopicsRootView.vue?vue&type=script&lang=js"
export * from "./eAristoStudentTopicsRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports